import { AutocompleteRenderOptionState } from "@mui/material/Autocomplete"
import { AccentedAutocompleteOption } from "../ServiceAutoCompleteStore"

const ServiceRenderOption = (props: React.HTMLAttributes<HTMLLIElement>, option: any, state: AutocompleteRenderOptionState) => {
   return <AccentedAutocompleteOption
      {...{ props, option, inputValue: state.inputValue, selected: state.selected }}
      key={option.id || 'add'}
   />
}

export default ServiceRenderOption
